import { Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { AdminService } from '../../../../services/admin.service';

@Component({
    selector: 'app-hirerchy-checker-run-command',
    imports: [CommonModule, ButtonModule],
    templateUrl: './hirerchy-checker-run-command.component.html',
    styleUrl: './hirerchy-checker-run-command.component.scss'
})
export class HirerchyCheckerRunCommandComponent {
  isProcessing: boolean = false;
  responseMessage: string | null = null;
  isSuccess: boolean = false;

  constructor(private adminService: AdminService) {}

  runHierarchyChecker() {
    if (this.isProcessing) {
      return;
    }

    this.isProcessing = true;
    this.responseMessage = null;
    
    // Call the admin service to run the hierarchy checker
    this.adminService.runHierarchyCheckerCommand().subscribe({
      next: (response) => {
        this.isSuccess = true;
        this.responseMessage = "The Hierarchy Checker successfully ran.";
        this.isProcessing = false;
      },
      error: (error) => {
        console.error('Error executing hierarchy checker command', error);
        this.isSuccess = false;
        this.responseMessage = error.message || "An error occurred while running the Hierarchy Checker.";
        this.isProcessing = false;
      }
    });
  }
}
